
/**
 * Check string valid URL
 * @param {string} string 
 * @returns Boolen
 */
export const isValidHttpUrl = (string) => {
    let regEx = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return regEx.test(string)
};